import * as types from './mutation-types'

const setLoading = (state, payload) => {
  state.isLoading = payload
}

const setError = (state, payload) => {
  state.error = payload
}

const setClinicBankAccounts = (state, payload) => {
  state.clinicBankAccounts = payload
}

const setClinicPaymentMethods = (state, payload) => {
  state.clinicPaymentMethods = payload
}

const setImportedOFX = (state, payload) => {
  state.importedOFX = payload
}

const setTransactions = (state, payload) => {
  state.transactions = payload
}

const setTransactionsCount = (state, payload) => {
  state.transactionsCount = payload
}

const setRevisionsCount = (state, payload) => {
  state.revisionsCount = payload
}

const setReconciledAutomaticallyCount = (state, payload) => {
  state.reconciledAutomaticallyCount = payload
}

const setMatchedCount = (state, payload) => {
  state.matchedCount = payload
}

const setDivergenceCount = (state, payload) => {
  state.divergenceCount = payload
}

const setUnmatchedCount = (state, payload) => {
  state.unmatchedCount = payload
}

const setFinalizedCount = (state, payload) => {
  state.finalizedCount = payload
}

const setArchivedCount = (state, payload) => {
  state.archivedCount = payload
}

const setReconciliationStatFilter = (state, payload) => {
  state.reconciliationStatFilter = payload
}

const emptyReconciliationPairingUi = () => ({
  matchedTransactions: [],
  foundByImportedId: {},
  enabledByImportedId: {}
})

const resetReconciliationPairingUi = state => {
  state.reconciliationPairingUi = emptyReconciliationPairingUi()
}

const setReconciliationPairingUi = (state, payload) => {
  const p = payload || {}
  state.reconciliationPairingUi = {
    matchedTransactions: Array.isArray(p.matchedTransactions)
      ? p.matchedTransactions.map(mt => ({ ...mt }))
      : [],
    foundByImportedId:
      p.foundByImportedId && typeof p.foundByImportedId === 'object'
        ? JSON.parse(JSON.stringify(p.foundByImportedId))
        : {},
    enabledByImportedId:
      p.enabledByImportedId && typeof p.enabledByImportedId === 'object'
        ? { ...p.enabledByImportedId }
        : {}
  }
}

const reconciliationAddMatched = (state, matchedTransaction) => {
  state.reconciliationPairingUi = {
    ...state.reconciliationPairingUi,
    matchedTransactions: [
      ...state.reconciliationPairingUi.matchedTransactions,
      matchedTransaction
    ]
  }
}

const reconciliationRemoveMatchedByImportedId = (state, importedId) => {
  state.reconciliationPairingUi = {
    ...state.reconciliationPairingUi,
    matchedTransactions:
      state.reconciliationPairingUi.matchedTransactions.filter(
        mt => mt.imported_transaction?.id !== importedId
      )
  }
}

const reconciliationSetFoundTransaction = (
  state,
  { importedId, transaction }
) => {
  const id = String(importedId)
  state.reconciliationPairingUi = {
    ...state.reconciliationPairingUi,
    foundByImportedId: {
      ...state.reconciliationPairingUi.foundByImportedId,
      [id]: transaction
    }
  }
}

const reconciliationRemoveFoundTransaction = (state, importedId) => {
  const id = String(importedId)
  const next = { ...state.reconciliationPairingUi.foundByImportedId }
  delete next[id]
  state.reconciliationPairingUi = {
    ...state.reconciliationPairingUi,
    foundByImportedId: next
  }
}

const reconciliationSetEnabledConciliation = (
  state,
  { importedId, enabled }
) => {
  const id = String(importedId)
  const next = { ...state.reconciliationPairingUi.enabledByImportedId }
  if (enabled) {
    next[id] = true
  } else {
    delete next[id]
  }
  state.reconciliationPairingUi = {
    ...state.reconciliationPairingUi,
    enabledByImportedId: next
  }
}

const setArchivedFromExtract = (state, payload) => {
  state.archivedFromExtract = Array.isArray(payload) ? payload : []
}

const addToArchivedFromExtract = (state, payload) => {
  state.archivedFromExtract = [...(state.archivedFromExtract || []), payload]
}

const removeFromArchivedFromExtract = (state, { entryId, fitId }) => {
  state.archivedFromExtract = (state.archivedFromExtract || []).filter(row => {
    const imp = row?.imported_transaction
    if (!imp) return true
    if (entryId != null && entryId !== '') {
      if (String(imp.bank_reconciliation_entry_id) === String(entryId)) {
        return false
      }
    }
    if (fitId != null && fitId !== '') {
      if (String(imp.fit_id) === String(fitId)) return false
    }
    return true
  })
}

const removeArchivedEntryFromApiList = (state, { entryId, fitId }) => {
  state.archivedEntriesFromApi = (state.archivedEntriesFromApi || []).filter(
    entry => {
      if (entryId != null && entryId !== '') {
        const eid = entry.bank_reconciliation_entry_id ?? entry.id
        if (String(eid) === String(entryId)) return false
      }
      if (fitId != null && fitId !== '') {
        if (String(entry.fit_id) === String(fitId)) return false
      }
      return true
    }
  )
}

const setArchivedEntriesFromApi = (state, payload) => {
  state.archivedEntriesFromApi = Array.isArray(payload) ? payload : []
}

const setTransactionsLimit = (state, payload) => {
  state.transactionsLimit = payload
}

const setTransactionsLastPage = (state, payload) => {
  state.transactionsLastPage = payload
}

const setTransactionsPage = (state, payload) => {
  state.transactionsPage = payload
}

const setSumToPay = (state, payload) => {
  state.sumToPay = payload
}

const setSumToReceive = (state, payload) => {
  state.sumToReceive = payload
}

const setSelectedTransactions = (state, payload) => {
  state.selectedTransactions = payload
}

const setFilters = (state, payload) => {
  state.filters = payload
}

const addSelectedTransaction = (state, transaction) => {
  const exists = state.selectedTransactions.find(t => t.id === transaction.id)
  if (!exists) {
    state.selectedTransactions.push(transaction)
  }
}

const removeSelectedTransaction = (state, transactionId) => {
  state.selectedTransactions = state.selectedTransactions.filter(
    t => t.id !== transactionId
  )
}

const clearSelectedTransactions = state => {
  state.selectedTransactions = []
}

const setIsAutomaticReconciliation = (state, payload) => {
  state.isAutomaticReconciliation = payload
}

// OFX Form mutations
const setOFXFormField = (state, { field, value }) => {
  state.ofxForm[field] = value
}

const setOFXFormPeriod = (state, { start, end }) => {
  state.ofxForm.period.start = start
  state.ofxForm.period.end = end
}

const setOFXFormFile = (state, file) => {
  state.ofxForm.file = file
}

const resetOFXForm = state => {
  state.ofxForm = {
    clinic_id: null,
    bank_account_id: null,
    bank_account_name: null,
    period: {
      start: null,
      end: null
    },
    period_status: 'payment_date',
    period_order: 'asc',
    file: null
  }
}

const initializeOFXForm = (state, clinicId) => {
  state.ofxForm.clinic_id = clinicId
}

const setNewBillPrefillFromReconciliation = (state, payload) => {
  state.newBillPrefillFromReconciliation = payload
}

const setFilterIsReconciled = (state, payload) => {
  state.filters.is_reconciled = payload
}

const setReconciliationCounts = (state, payload) => {
  if (payload.reconciledAutomaticallyCount !== undefined)
    state.reconciledAutomaticallyCount = payload.reconciledAutomaticallyCount
  if (payload.matchedCount !== undefined)
    state.matchedCount = payload.matchedCount
  if (payload.divergenceCount !== undefined)
    state.divergenceCount = payload.divergenceCount
  if (payload.unmatchedCount !== undefined)
    state.unmatchedCount = payload.unmatchedCount
  if (payload.revisionsCount !== undefined)
    state.revisionsCount = payload.revisionsCount
  if (payload.finalizedCount !== undefined)
    state.finalizedCount = payload.finalizedCount
}

export default {
  setLoading,
  setError,
  setClinicBankAccounts,
  setClinicPaymentMethods,
  setImportedOFX,
  setTransactions,
  setTransactionsCount,
  setReconciledAutomaticallyCount,
  setMatchedCount,
  setDivergenceCount,
  setUnmatchedCount,
  setRevisionsCount,
  setFinalizedCount,
  setReconciliationCounts,
  setArchivedCount,
  setReconciliationStatFilter,
  resetReconciliationPairingUi,
  setReconciliationPairingUi,
  reconciliationAddMatched,
  reconciliationRemoveMatchedByImportedId,
  reconciliationSetFoundTransaction,
  reconciliationRemoveFoundTransaction,
  reconciliationSetEnabledConciliation,
  setArchivedFromExtract,
  addToArchivedFromExtract,
  removeFromArchivedFromExtract,
  removeArchivedEntryFromApiList,
  setArchivedEntriesFromApi,
  setTransactionsLimit,
  setTransactionsLastPage,
  setTransactionsPage,
  setSumToPay,
  setSumToReceive,
  setSelectedTransactions,
  setFilters,
  setFilterIsReconciled,
  addSelectedTransaction,
  removeSelectedTransaction,
  clearSelectedTransactions,
  setOFXFormField,
  setOFXFormPeriod,
  setOFXFormFile,
  resetOFXForm,
  initializeOFXForm,
  setNewBillPrefillFromReconciliation,
  setIsAutomaticReconciliation,
  [types.ADD_ITEM](state, item) {
    state.items.push(item)
  },
  [types.ADD_SELECTED_TRANSACTION](state, transaction) {
    addSelectedTransaction(state, transaction)
  },
  [types.REMOVE_SELECTED_TRANSACTION](state, transactionId) {
    removeSelectedTransaction(state, transactionId)
  },
  [types.CLEAR_SELECTED_TRANSACTIONS](state) {
    clearSelectedTransactions(state)
  },
  [types.SET_OFX_FORM_FIELD](state, payload) {
    setOFXFormField(state, payload)
  },
  [types.SET_OFX_FORM_PERIOD](state, payload) {
    setOFXFormPeriod(state, payload)
  },
  [types.SET_OFX_FORM_FILE](state, file) {
    setOFXFormFile(state, file)
  },
  [types.RESET_OFX_FORM](state) {
    resetOFXForm(state)
  },
  [types.INITIALIZE_OFX_FORM](state, clinicId) {
    initializeOFXForm(state, clinicId)
  }
}
